// The two screening credentials a company check can produce, watchlist screening and adverse
// media screening, and the rule for when one expires. A screening credential is valid until the
// end of the same calendar day (UTC) one year after the screening date on the provider's report,
// whatever its result.
//
// Written as plain CommonJS so the API server, which runs its files under plain node, can require
// this same file the browser bundle imports.

const SCREENING_DOC_KEYS = ['watchlist', 'adverse-media'];

const SCREENING_TYPES = {
  watchlist: {
    docKey: 'watchlist',
    reportType: 'report/business-watchlist',
    documentName: 'Watchlist Screening',
    displayName: 'Watchlist screening',
  },
  'adverse-media': {
    docKey: 'adverse-media',
    reportType: 'report/business-adverse-media',
    documentName: 'Adverse Media Screening',
    displayName: 'Adverse media screening',
  },
};

// The fields a screening credential is shared with: its type, result, date and report reference.
const SCREENING_SHARED_FIELDS = Object.freeze(['screeningType', 'result', 'screenedAt', 'reportId']);

const SCREENING_RESULTS = {
  NO_MATCHES: 'no_matches',
  MATCH_REPORTED: 'match_reported',
};

const RESULT_LABELS = {};
RESULT_LABELS[SCREENING_RESULTS.NO_MATCHES] = 'No matches';
RESULT_LABELS[SCREENING_RESULTS.MATCH_REPORTED] = 'Match reported';

const isScreeningDocKey = key => SCREENING_DOC_KEYS.includes(key);

// Accepts a report type ("report/business-watchlist") or a report event name, which is the
// report type followed by a dot and the event ("report/business-watchlist.ready").
const screeningTypeForReportType = type => {
  if (typeof type !== 'string') return null;
  const match = SCREENING_DOC_KEYS.map(key => SCREENING_TYPES[key]).find(
    entry => type === entry.reportType || type.startsWith(`${entry.reportType}.`)
  );
  return match || null;
};

const screeningExpiryDate = screenedAt => {
  const screened = new Date(screenedAt);
  return new Date(
    Date.UTC(
      screened.getUTCFullYear() + 1,
      screened.getUTCMonth(),
      screened.getUTCDate(),
      23,
      59,
      59,
      999
    )
  );
};

// A missing or unreadable expiry date counts as expired.
const isScreeningExpired = ({ expiryDate } = {}, now = new Date()) => {
  if (!expiryDate) return true;
  const expiry = new Date(expiryDate).getTime();
  if (Number.isNaN(expiry)) return true;
  return new Date(now).getTime() > expiry;
};

const screeningResultLabel = result => RESULT_LABELS[result];

module.exports = {
  SCREENING_DOC_KEYS,
  SCREENING_TYPES,
  SCREENING_RESULTS,
  SCREENING_SHARED_FIELDS,
  isScreeningDocKey,
  screeningTypeForReportType,
  screeningExpiryDate,
  isScreeningExpired,
  screeningResultLabel,
};
